"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.useResetPassword = void 0;
var _react = require("react");
const useResetPassword = authImplementation => {
  return (0, _react.useCallback)(async options => {
    if (authImplementation.resetPassword) {
      return await authImplementation.resetPassword(options);
    } else {
      throw new Error(`Auth client ${authImplementation.type} does not implement this function`);
    }
  }, [authImplementation]);
};
exports.useResetPassword = useResetPassword;